var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSteerLogoMobile = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    width: 44,
    height: 42.038,
    viewBox: "0 0 44 42.038",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34575",
    "data-name": "Group 34575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61535",
    "data-name": "Path 61535",
    d: "M33,2H11L0,21.055,11,40.105H33L44,21.055ZM26.224,31.753H11.307l1-5.318h12.58v1.477l4.394-2.87-4.394-2.87v1.537H17.777a6.681,6.681,0,0,1,0-13.362H32.7l-1,5.322H19.125V14.131L14.731,17l4.394,2.87V18.394h7.1a6.681,6.681,0,0,1,0,13.362h0Z",
    transform: "translate(0 -1.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34573",
    "data-name": "Group 34573",
    transform: "translate(18.374 34.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62795",
    "data-name": "Path 62795",
    d: "M60.735,71.9H42.124l-4.54,7.862H56.193Z",
    transform: "translate(-37.584 -71.903)",
    fill: "#005cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62796",
    "data-name": "Path 62796",
    d: "M39.854,79.944H58.463l-2.27,3.932H37.584Z",
    transform: "translate(-37.584 -76.013)",
    fill: "#ffd400"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSteerLogoMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/steer-logo-mobile.e650709f.svg";
export { ForwardRef as ReactComponent };